import React from 'react'

interface PillProps {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  variant?: 'primary' | 'light'
}

const styles = {
  pill: {
    display: 'inline-block',
    padding: 'var(--spacing-xs) var(--spacing-sm)',
    borderRadius: '50px',
    fontSize: 'var(--font-size-xxs)',
    lineHeight: 1,
    fontWeight: 500,
  },
  primary: {
    background: 'var(--color-pill-bg)',
    color: 'var(--color-primary)',
  },
  light: {
    background: 'var(--color-accent)',
    color: 'var(--color-text)',
  },
}

const Pill: React.FC<PillProps> = ({
  children,
  className,
  style,
  variant = 'primary',
}) => {
  return (
    <span
      style={{
        ...styles.pill,
        ...styles[variant],
        ...style,
      }}
      className={className}
    >
      {children}
    </span>
  )
}

export default Pill
